"use server"

import { ecrireReponse, estStatut } from "@/lib/data/store"

/**
 * Enregistre la réponse du client sur un créneau, pour qu'elle survive au
 * rechargement. Appelée depuis le dashboard (composant client) à chaque bascule.
 *
 * On revalide toutes les entrées (elles peuvent venir d'un POST direct, pas
 * seulement de l'UI) : jour dans la semaine, statut connu. En cas d'entrée
 * douteuse, on ignore silencieusement plutôt que d'écrire n'importe quoi — le
 * client garde de toute façon son état optimiste à l'écran.
 *
 * TODO — quand l'auth locale existera, tirer `clientId` de la session plutôt
 * que de le recevoir en argument (un POST ne doit pas pouvoir écrire chez autrui).
 */
export async function enregistrerReponse(
  clientId: string,
  tacheId: string,
  jour: number,
  statut: string
): Promise<void> {
  if (!clientId || !tacheId) return
  if (!Number.isInteger(jour) || jour < 0 || jour > 6) return
  if (!estStatut(statut)) return

  ecrireReponse(clientId, tacheId, jour, statut)
}
